// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  selecionarQuantidadeJanelas,
  getQuantidadeJanelasSelecionada,
} from "../../../../../../state";
import { QUANTIDADE_DEFAULT_JANELA } from "../../../../../../model";

type Prop = {
  numeroJanelas: number,
  selecionarQuantidadeJanelas: ActionCreator,
};

function SelecaoNumeroJanelas({
  numeroJanelas,
  selecionarQuantidadeJanelas,
}: Prop) {
  function onNumeroJanelasChange(numeroJanelas) {
    selecionarQuantidadeJanelas(numeroJanelas);
  }

  function onBlur() {
    if (!numeroJanelas) {
      selecionarQuantidadeJanelas(QUANTIDADE_DEFAULT_JANELA);
    }
  }

  return (
    <>
      <label className="ConfiguracaoMedida__label">
        <Translate>periodos.janela.numeroJanelas</Translate>
      </label>
      <NumberField
        className="ConfiguracaoMedida__input"
        allowNegative={false}
        max={365}
        min={1}
        onChangeValue={onNumeroJanelasChange}
        value={numeroJanelas}
        onBlur={onBlur}
      />
    </>
  );
}

export default connect(
  state => ({
    numeroJanelas: getQuantidadeJanelasSelecionada(state),
  }),
  { selecionarQuantidadeJanelas }
)(SelecaoNumeroJanelas);
